module.exports = __webpack_public_path__ + "static/media/picto_type_clinic.3506dd2b.svg";